import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { SVGIcon } from 'components/buttons/IconSVG';
import { CommonBG, CommonBorder, ControlFilldBG, CommonText } from 'ui/theme/Color';

export const NumberSize = [
  css`
    width: 26px;
    height: 26px;
    font-size: 14px;
  `,
  css`
    width: 28px;
    height: 28px;
    font-size: 15px;
  `,
  css`
    width: 30px;
    height: 30px;
    font-size: 16px;
  `,
  css`
    width: 32px;
    height: 32px;
    font-size: 17px;
  `,
  css`
    width: 34px;
    height: 34px;
    font-size: 18px;
  `,
  css`
    width: 36px;
    height: 36px;
    font-size: 19px;
  `,
  css`
    width: 38px;
    height: 38px;
    font-size: 20px;
  `,
  css`
    width: 40px;
    height: 40px;
    font-size: 21px;
  `,
  css`
    width: 42px;
    height: 42px;
    font-size: 22px;
  `,
  css`
    width: 44px;
    height: 44px;
    font-size: 23px;
  `,
  css`
    width: 46px;
    height: 46px;
    font-size: 24px;
  `,
];

export const SetupHome = styled.div`
  overflow: hidden;
  position: relative;
  height: calc(100vh - 168px);
  min-height: 400px;
  background: url(/assets/setupHome/main-map.png) no-repeat 63px 132px;
  background-size: 1200px auto;
  .ProjectStatusWrap {
    position: absolute;
    top: 208px;
    left: 1360px;
  }
  .title {
    h3 {
      font-size: 32px;
      font-weight: bold;
    }
    p {
      font-size: 13px;
      font-weight: 600;
      color: ${CommonText.Lighter};
      letter-spacing: -0.5px;
    }
  }
  .ProjectStatus {
    margin-top: 30px;
    > div,
    ul {
      display: flex;
    }
    li {
      > span {
        font-weight: 600;
        color: ${CommonBG.Primary};
      }
    }
    .total {
      h4 {
        margin-right: 20px;
        font-size: 13px;
        font-weight: 600;
      }
      li {
        margin-right: 12px;
        font-size: 13px;
      }
    }

    .status {
      margin-top: 12px;
      li {
        font-size: 12px;
        padding: 6px 8px;
        margin-right: 4px;
        border-radius: 3px;
        border: 1px solid ${CommonBorder.Basic};
        background-color: ${CommonBorder.Bright};
      }
    }
  }
`;

export const ProjectListWrap = styled.div`
  position: relative;
`;

export const ProjectList = styled.div<{ count: number }>`
  position: absolute;
  display: table;
  text-align: center;
  ${({ count }) => count >= 6 && 'transform: translate(-118px);'};

  &.reverse {
    > span {
      margin-bottom: 12px;
    }
    ul {
      align-content: flex-start;
    }
    li {
      &:before {
        top: -9px;
        bottom: auto;
        border-bottom: 8px solid #dde0df;
        border-top: 0;
      }
      &:after {
        top: -8px;
        bottom: auto;
        border-bottom: 8px solid #fff;
        border-top: 0;
      }
    }
  }
  > .reverse {
    position: static;
    transform: none;
    margin-top: 12px;
    > span {
      margin-bottom: 0;
    }
  }
`;

export const StatusNumber = styled.span<{ size?: number }>`
  ${({ size = 0 }) => NumberSize[Math.min(size, 10)]}
  transform: translateX(-50%);
  margin-left: 50%;
  margin-top: 8px;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
  border-radius: 50%;
  letter-spacing: -0.5px;
  font-weight: 600;
  background-color: #000;
  font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', Sans-Serif;
`;

export const ListItemWrap = styled.ul<{ count: number }>`
  width: ${({ count }) => (count > 5 ? '466px' : '230px')};
  height: 260px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-end;
  gap: 4px;
`;

export const ListItem = styled.li<{ selected?: boolean }>`
  position: relative;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
  justify-content: space-between;
  width: 230px;
  padding: 6px 8px;
  border: 1px #dfdfdf solid;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  > strong {
    font-size: 14px;
  }
  > span {
    > button {
      //     border-color: ${CommonBorder.Strong};
      //     background: ${CommonBG.Deeper};
      //     &:last-child {
      //         border-color: ${CommonBorder.Stronger};
      //    }
    }
  }
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -9px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #dde0df;
  }
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -8px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
  }
  &:hover {
    border-color: ${CommonBorder.Strong};
    background-color: ${CommonBG.Deeper};
    &:after {
      border-top-color: ${ControlFilldBG.Basic};
    }
    &:before {
      border-top-color: ${CommonBorder.Strong};
    }
  }
  ${({ selected }) =>
    selected &&
    `
        color: ${CommonBG.Basic};
        border-color:  ${CommonBG.Primary};
        background-color: ${CommonBG.Primary};
        &:hover {
            border-color:  ${CommonBG.Primary};
            background-color: ${CommonBG.Primary};
            &:after {border-top-color:  ${CommonBG.Primary}}
            &:before {border-top-color: ${CommonBG.Primary}}   
        }
        &:before,
        &:after { 
            border-top-color: ${CommonBG.Primary};
        }
      
    `}
`;

export const ProjectView = styled.div<{ show: boolean }>`
    display: ${({ show }) => (show ? 'block' : 'none')};
    position: absolute;
    right: 0;
    width: 360px;
    padding: 12px;
    border:1px ${CommonBorder.Basic} solid;
    font-size: 13px;
    background: ${CommonBG.Deep};
    .popup,
    .cancel {
        width: 20px;
        height: 20px;
        padding: 0;
        &:before {
        left: 50%;
        }
    }
    .popup {
        &:before {
            mask-size: 90%;
            mask-repeat: no-repeat;
            transform: translate(-60%, -40%);
        }
    }
    
    .header {
        position: relative;
        h4 {
            margin: 6px 0 12px 0;
            font-size: 14px;
            font-weight: 600;
        }
        .btn {
            position:absolute; 
            top: 0; 
            right: 0;
            display: flex;
            span {
                margin-right: 12px;
                font-weight: 600;
            }
        }
        .popup {
            &:before {
                mask-size: 90%;
                mask-repeat: no-repeat;
                transform: translate(-60%, -40%);
            }
        }
        .cancel {
            &:before {
                mask-size: 120%;
                transform: translate(-60%, -50%);
            }
        }
    }
    .tabWrap {
        background: ${CommonBG.Basic}
    } 

    .filtterWrap {
        display: flex;
        align-items: center;
        padding: 8px 0;
        height: 38px;
        font-size: 12px;
        letter-spacing: -0.5px;
        > span {
            margin-right: 8px;
            font-weight: 600;
        }
        .filterList {
            display: flex;
            align-items: center;
            ul {
                display: flex;
                align-items: center;
                overflow: hidden;
                width: 237px;
                gap: 4px;
                li {
                    display: flex;
                    align-items: center;
                    padding: 0 2px 0 8px;
                    font-size: 10px;
                    font-weight: 600;
                    white-space: nowrap;
                    border-radius: 16px;
                    border: 1px solid ${CommonBorder.Strong};
                    background: ${CommonBG.Basic};
                    line-height: 20px;
                }
            }
        }
    button {
        padding:0;
        width: 18px;
        width: 18px;
        &:before {
            left: 50%;
            transform: translate(-50%, -50%);
            background: #000;
        }
        &.filterOff {
            cursor: default;
            &:before {
                margin-top: 3px;
            }
        }
        &.left {
            &:before {
            transform: translate(-50%, -50%) rotate(90deg);
            }
            
        }
        &.right {
            &:before {
            transform: translate(-50%, -50%) rotate(-90deg); 
            }
            
        }
    }
`;

export const ProjectKanban = styled.div`
  height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 300px;
`;

export const KanbanList = styled.div`
  position: relative;
  padding: 12px;
  background: ${CommonBG.Basic};
  border: 1px solid ${CommonBorder.Basic};
  border-left: 4px solid ${CommonBG.Primary};
  border-radius: 4px;
  height: 120px;
  margin-bottom: 12px;
  font-size: 12px;
  .header {
    position: relative;
    margin-bottom: 6px;
    .status {
      position: absolute;
      display: block;
      width: 60px;
      padding: 2px 5px;
      font-size: 10px;
      font-weight: 600;
      text-align: center;
      // font-weight: 600;
      color: ${CommonText.Light};
      border: 1px solid ${CommonBorder.Strong};
      border-radius: 2px;
      background: ${CommonBorder.Bright};
      box-sizing: border-box;
    }
    h5 {
      margin-bottom: 4px;
      padding-left: 68px;
      font-weight: 600;
      line-height: 22.5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span:not(.status) {
      margin-right: 12px;
      font-weight: 600;
      color: ${CommonText.Lighter};
    }
  }
  .user {
    position: absolute;
    left: 12px;
    bottom: 17px;
    display: flex;
    align-items: center;
    .photo {
      height: 22px;
      width: 22px;
      margin-right: 6px;

      border: 1px solid ${CommonBorder.Stronger};
      border-radius: 50%;
      display: inline-block;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.9999 6.8C10.5463 6.8 11.7999 5.5464 11.7999 4C11.7999 2.4536 10.5463 1.2 8.9999 1.2C7.45351 1.2 6.1999 2.4536 6.1999 4C6.1999 5.5464 7.45351 6.8 8.9999 6.8ZM8.9999 8C11.209 8 12.9999 6.20914 12.9999 4C12.9999 1.79086 11.209 0 8.9999 0C6.79076 0 4.9999 1.79086 4.9999 4C4.9999 6.20914 6.79076 8 8.9999 8Z' fill='%235B5C5B'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 17.3C0 12.8265 3.62649 9.20005 8.1 9.20005H9.89999C14.3735 9.20005 18 12.8265 18 17.3V17.4C18 17.7314 17.7314 18 17.4 18C17.0686 18 16.8 17.7314 16.8 17.4V17.3C16.8 13.4893 13.7108 10.4 9.89999 10.4H8.1C4.28923 10.4 1.2 13.4893 1.2 17.3V17.4C1.2 17.7314 0.931371 18 0.6 18C0.268629 18 0 17.7314 0 17.4V17.3Z' fill='%235B5C5B'/%3E%3C/svg%3E")
        no-repeat 50% 50%;
    }
    .name {
      font-weight: 600;
    }
  }
  .etc {
    position: absolute;
    right: 12px;
    bottom: 12px;
    display: flex;
    align-items: center;
    .Graph {
      display: inline-block;
      height: 32px;
      width: 32px;
      margin: 0 24px 0 8px;
      border-radius: 50%;
      background: ${CommonBG.Strong};
    }
  }
`;
